export const sortAllView = data => {
  const views = {
    list: {
      nameOfList: [],
      allViews: {},
    },
    status: {
      nameOfList: [],
      allViews: {},
    },
    milestone: {
      nameOfList: [],
      allViews: {},
    },
    combined: {
      nameOfList: [],
      allViews: {},
    },
  };
  data.forEach(item => {
    if (item.sub_type) {
      views[item.sub_type["id"]]["allViews"] = {
        ...views[item.sub_type["id"]]["allViews"],
        [item.name]: item.sequence,
      };
      views[item.sub_type["id"]].nameOfList.push({
        name: item.name,
        id: item.id,
        is_view_rule_exists: Boolean(item.filter_criteria),
      });
    } else {
      views["list"]["allViews"] = {
        ...views["list"]["allViews"],
        [item.name]: item.sequence,
      };
      views["list"].nameOfList.push({
        name: item.name,
        id: item.id,
        is_view_rule_exists: Boolean(item.filter_criteria),
      });
    }
  });

  return views;
};

/**
 * Groups records by known milestones, retaining unmatched records in Uncategorized.
 * @param {Array<Object>} data The records on the current page.
 * @param {Array<Object>} milestoneList The available milestone definitions.
 * @return {{filterd: Object<string, Array<number>>, mapConsignments: Object<number, Object>}}
 */
export const filterOrderByMilestone = (data = [], milestoneList) => {
  const mapConsignments = {};
  const filterd = { Uncategorized: [] };
  milestoneList.forEach(item => {
    filterd[item.id] = [];
  });

  data?.forEach(item => {
    mapConsignments[item.id] = item;
    if (item.milestone?.id && filterd[item.milestone.id]) {
      filterd[item.milestone.id].push(item.id);
    } else {
      filterd.Uncategorized.push(item.id);
    }
  });
  return { filterd, mapConsignments };
};

const mapNameForViewRule = {
  purchase: "purchase",
  shipment: "shipments",
  transfer: "transfers",
  inventory: "stock summary",
  inventoryDetail: "stock line details",
  inventoryTransactions: "transactions",
  customerReturn: "customer returns",
};

export const getNameForViewRule = orderType => {
  let nameForOrders = "orders";
  if (mapNameForViewRule[orderType]) nameForOrders = mapNameForViewRule[orderType];
  return nameForOrders;
};
